export default __webpack_public_path__ + "static/media/error.7bc5d145.svg";